import React, { memo, Fragment, useState, useEffect } from 'react';
import Button from 'b2b-ui-components-lib/lib/components/button';
import Input from 'b2b-ui-components-lib/lib/components/input';
import { formSchema } from './formControl';
import { stopBackgroundScrolling } from 'common/utils/app.utils';

type Props = {
  defaultEmail: string;
  title: string;
  content: string;
  onSubmit: Function;
  onCancel: Function;
  isLoading: boolean;
};

export const EmailPricingProposal: React.FC<Props> = memo(({ title, content, isLoading, onSubmit, onCancel, defaultEmail }) => {
  const [form, setForm] = useState(formSchema);

  const onEmailChange = (value: string) => {
    setForm({ ...form, email: { ...form.email, value, touched: true, errors: form.email.validator(value) as any } });
  };

  const onFieldBlur = (formElement: { value: string; validator: Function; errors: Array<string> }, keyName: string) => {
    const { value, validator, errors: existingError } = formElement;
    let errors = [];
    if (typeof validator === 'function') {
      errors = validator(value);
    }
    setForm({ ...form, [keyName]: { ...(form as any)[keyName], value, errors: errors.concat(existingError), touched: true } });
  };

  const onSend = () => {
    onSubmit(form?.email.value);
  };

  const isError = () => {
    return form?.email.errors.length > 0 || !form?.email.touched;
  };

  useEffect(() => {
    stopBackgroundScrolling(true);
    if (defaultEmail) {
      onEmailChange(defaultEmail);
    }
    return () => {
      stopBackgroundScrolling(false);
    };
  }, []);

  return (
    <Fragment>
      <div className="modal-custom open">
        <div className="modal_dialog contract_modal">
          <div className="modal_content">
            <div className="modal_header">
              <h5>{title}</h5>
            </div>
            <div className="modal_body">
              <div className="plan_condition custom-modal-dec">{content}</div>
              <div className="plan_condition custom-modal-dec">
                <Input
                  label="Email"
                  required
                  value={form.email.value}
                  onBlur={() => onFieldBlur(form.email, 'email')}
                  errors={form.email.errors}
                  touched={form.email.touched}
                  onChange={onEmailChange}
                  key="email"
                />
              </div>
              <div className="next_step">
                <Button disabled={isLoading} variant="outlinebtn" onClick={onCancel}>
                  Cancel
                </Button>
                <Button disabled={isLoading || isError()} variant="activebtn" onClick={onSend}>
                  Send
                  {isLoading && <span className="loading_icon"></span>}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
});
